import { Machine } from 'xstate';

export default Machine({
  key: 'sideBarTickets',
  initial: 'loading',
  states: {
    loading: {
      on: {
        TICKETS: 'tickets',
        ERROR: 'error',
      },
    },
    tickets: {},
    error: {
      on: {
        RETRY: 'loading',
        CANCEL: 'ticket',
      },
    },
  },
});
